import { useContext, useState } from "react";
import { Box, Container, Grid, Tab, Tabs, Typography, useTheme, Card } from "@mui/material";
import UserContext from "../../../navigation/context/userContext";
import CompanyProfileImages from "./images";
import CustomBreadcrumbs from "../../../components/breadcrumbs";
import Socials from "./Socials";
import WorkingHours from "./workingHours";
import DatosGenerales from "./datosGenerales";
import Ubicacion from "./ubicacion";
import Contactos from "./contactos";
import PropTypes from 'prop-types';

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`profile-tabpanel-${index}`}
      aria-labelledby={`profile-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ pt: 3 }}>
          {children}
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `profile-tab-${index}`,
    'aria-controls': `profile-tabpanel-${index}`,
  };
}

export default function CompanyProfile() {
    const [value, setValue] = useState(0);
    const { userData } = useContext(UserContext);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <Container maxWidth='xl' sx={{ py: { xs: 2, sm: 4 }, mb: 8 }}>
            <CustomBreadcrumbs returnTo='/' crumbs={[{ name: 'Perfil Comercial', link: '/profile' }]} />
            
            {/* --- HEADER --- */}
            <Box sx={{ mt: 3, mb: 4 }}>
                <Typography variant="h4" fontWeight={800} sx={{ color: '#222', fontSize: { xs: '1.5rem', sm: '2rem' } }}>
                    Configuración del Perfil
                </Typography>
                <Typography variant="body2" sx={{ color: '#666', mt: 0.5 }}>
                    Actualiza la información pública de tu comercio, horarios y detalles de contacto.
                </Typography>
            </Box>

            {/* --- TABS DE NAVEGACIÓN HORIZONTAL --- */}
            <Box sx={{ borderBottom: 1, borderColor: '#e0e0e0', mb: 3 }}>
                <Tabs 
                    value={value} 
                    onChange={handleChange} 
                    variant="scrollable" 
                    scrollButtons="auto" 
                    allowScrollButtonsMobile 
                    indicatorColor="primary"
                >
                    <Tab label={<Typography fontWeight="bold" variant="body2" textTransform="none">Información General</Typography>} {...a11yProps(0)} />
                    <Tab label={<Typography fontWeight="bold" variant="body2" textTransform="none">Ubicación</Typography>} {...a11yProps(1)} />
                    <Tab label={<Typography fontWeight="bold" variant="body2" textTransform="none">Contacto</Typography>} {...a11yProps(2)} />
                    <Tab label={<Typography fontWeight="bold" variant="body2" textTransform="none">Redes Sociales</Typography>} {...a11yProps(3)} />
                    <Tab label={<Typography fontWeight="bold" variant="body2" textTransform="none">Horarios</Typography>} {...a11yProps(4)} />
                    <Tab label={<Typography fontWeight="bold" variant="body2" textTransform="none">Imágenes</Typography>} {...a11yProps(5)} />
                </Tabs>
            </Box>

            {/* --- CONTENIDO --- */}
            <Box>
                <TabPanel value={value} index={0}>
                    <DatosGenerales />
                </TabPanel>
                <TabPanel value={value} index={1}>
                    <Ubicacion />
                </TabPanel>
                <TabPanel value={value} index={2}>
                    <Contactos />
                </TabPanel>
                <TabPanel value={value} index={3}>
                    <Socials />
                </TabPanel>
                <TabPanel value={value} index={4}>
                    <WorkingHours />
                </TabPanel>
                <TabPanel value={value} index={5}>
                    <CompanyProfileImages />
                </TabPanel>
            </Box>
        </Container>
    );
}